import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query getNarrativeValuation($companyId: String!) {
    Company(id: $companyId) {
      data {
        currencyInfo
      }
      analysisValue {
        npvPerShare
        lastSharePrice
      }
      myValuation {
        fairValue
        narrative {
          id
          owner {
            displayName
            imageUrl
          }
          updatedAt
          valuations {
            fairValue
            createdAt
          }
          draftUpdate {
              title
              valuation {
                fairValue
              }
          }
        }
      }
      defaultNarrative {
        title
        updatedAt
        valuation {
          fairValue
        }
        valuations {
          fairValue
          createdAt
        }
      }
    }
  }
`
);

export const useNarrativeValuation = makeGqlQuery(QUERY, {
  tags: ['narrative'],
});
